import { useSelector } from "react-redux";

const UseRevisionsPermissions = () => {
  // Add defensive checks to prevent undefined errors
  const permissions = useSelector(
    (state) => state.projectReducer?.permissions
  ) || {};
  
  const revisions = permissions.revisions || {};

  // Default to true if permissions are not available
  let canView = revisions?.view ?? true;
  let canEdit = revisions?.add_edit ?? true;
  let canDelete = revisions?.delete ?? true;

  return [canView, canEdit, canDelete];
};

export default UseRevisionsPermissions;
